// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    /*
        This page contains multiple products displayed in a swiper.
        Each slide is for its own product, and contains a nested swiper to switch between the different products
     */


    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // swiper
    const productSwiper = new Swiper(section.querySelector('.productV19'), {
        slidesPerView: 1,
        spaceBetween: 200,
        allowTouchMove: false,
        effect: "fade"
    });

    const discountMultiplier = 0.88 // 12% discount

    // nested swipers (product selection)
    section.querySelectorAll('.productV19ItemProducts').forEach(function (swiper) {
        new Swiper(swiper, {
            slidesPerView: "auto",
            spaceBetween: 14,
            nested: true,
            scrollbar: {
                el: swiper.querySelector('.productV19ItemProductsTrack'),
                draggable: true,
            },
            breakpoints: {
                1160: {
                    spaceBetween: 16
                }
            }
        });
    });

    // nested swipers (image gallery)
    section.querySelectorAll('.productV19ItemSwiper')?.forEach(function (swiper) {
        new Swiper(swiper, {
            slidesPerView: 1,
            spaceBetween: 20,
            nested: true,
            loop: true,
            navigation: {
                nextEl: swiper.querySelector('.productV19ItemSwiperBtn.next'),
                prevEl: swiper.querySelector('.productV19ItemSwiperBtn.prev'),
            }

        });

    });

    // product change
    section.querySelectorAll('.productV19ItemProductsSlideLabelInput').forEach(function (input) {
        input.addEventListener('change', async function () {

            let product = JSON.parse(input.value);

            // sync all the product radio inputs
            section.querySelectorAll('.productV19ItemProductsSlideLabelInput').forEach(function (otherInput) {
                if (otherInput !== input && otherInput.dataset.index === input.dataset.index) {
                    otherInput.checked = true;
                }
            });

            // slide all the nested swipers to the selected product
            section.querySelectorAll('.productV19ItemProducts').forEach(function (swiper) {
                const nestedSwiper = swiper.swiper;
                nestedSwiper.slideTo(parseInt(input.dataset.index) - 1);
            });

            // change slides
            productSwiper.slideTo(parseInt(input.dataset.index) - 1);


            // update FAQ section
            document.querySelectorAll('.secFAQ').forEach(function (faqSection) {
                if (faqSection.dataset.id === input.dataset.target) {
                    faqSection.classList.add('active');
                } else {
                    faqSection.classList.remove('active');
                }
            })

            // update ingredients section
            document.querySelectorAll('.secIngredients').forEach(function (ingredsSection) {
                if (ingredsSection.dataset.id === input.dataset.target) {
                    ingredsSection.classList.add('active');
                } else {
                    ingredsSection.classList.remove('active');
                }
            })

            // update reviews section
            document.querySelectorAll('.secReviews').forEach(function (reviewsSection) {
                if (reviewsSection.dataset.id === input.dataset.target) {
                    reviewsSection.classList.add('active');
                } else {
                    reviewsSection.classList.remove('active');
                }
            })
        });
    })

    section.querySelectorAll('.productV19Item').forEach(function (productSection) {

        // update product on variant change
        productSection.querySelectorAll('.productV19ItemVariantsLabelInput').forEach(function (input) {
            input.addEventListener('change', function () {
                updateProduct();
            });
        })

        // update product
        function updateProduct() {
            // find selected variant
            let product = JSON.parse(productSection.querySelector('.productV19ItemProductsSlideLabelInput:checked').value);
            let variant = JSON.parse(productSection.querySelector('.productV19ItemVariantsLabelInput:checked').value);
            // skio:filter:start
            // was: let variantPlan = variant.selling_plan_allocations[0];
            let variantPlan = skioAllocs(variant, product)[0];
            // skio:filter:end
            let quantity = parseInt(productSection.querySelector('.productV19ItemQtyVal').textContent);

            // update selling plan options
            let optionsHTML = "";
            // skio:filter:start
            // was: variant.selling_plan_allocations.forEach(sellingPlanAllocation => {
            skioAllocs(variant, product).forEach(sellingPlanAllocation => {
            // skio:filter:end
                // find the selling plan name since it's not in the object
                let sellingPlan = getSellingPlanById(product, sellingPlanAllocation.selling_plan_id);

                // create an option for the select
                optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
            });
            productSection.querySelector('.productV19ItemPlan').innerHTML = optionsHTML;

            // update ATC
            if (variant.available) {
                productSection.querySelector('.productV19ItemATC').disabled = false;
                productSection.querySelector('.productV19ItemATCTxt').textContent = 'add to cart -';
                productSection.querySelector('.productV19ItemATCPrice').textContent = price(variantPlan.price * quantity * discountMultiplier, true);
                productSection.querySelector('.productV19ItemATCCompare').textContent = variantPlan.compare_at_price * quantity ? price(variantPlan.compare_at_price * quantity, true) : '';
            } else {
                productSection.querySelector('.productV19ItemATC').disabled = true;
                productSection.querySelector('.productV19ItemATCTxt').textContent = 'sold out';
                productSection.querySelector('.productV19ItemATCPrice').textContent = '';
                productSection.querySelector('.productV19ItemATCCompare').textContent = '';
            }
        }

        // initial update
        updateProduct();


        // quantity controls

        // minus
        productSection.querySelector(".productV19ItemQtyItem.minus")?.addEventListener("click", function () {
            let quantity = parseInt(productSection.querySelector(".productV19ItemQtyVal").textContent);
            if (quantity === 1) {
                return;
            }
            quantity--;
            productSection.querySelector(".productV19ItemQtyVal").textContent = quantity;
            updateProduct();
        });

        // plus
        productSection.querySelector(".productV19ItemQtyItem.plus")?.addEventListener("click", function () {
            let quantity = parseInt(productSection.querySelector(".productV19ItemQtyVal").textContent);

            quantity++;
            productSection.querySelector(".productV19ItemQtyVal").textContent = quantity;
            updateProduct();
        });


        // add to cart
        productSection.querySelector('.productV19ItemATC').addEventListener("click", async function () {
            this.classList.add("loading");

            let variant = JSON.parse(productSection.querySelector('.productV19ItemVariantsLabelInput:checked').value);
            let sellingPlanId = parseInt(productSection.querySelector('.productV19ItemPlan').value);
            let quantity = parseInt(productSection.querySelector('.productV19ItemQtyVal').textContent);

            await addProduct({
                items: [{
                    quantity: quantity,
                    id: variant.id,
                    selling_plan: sellingPlanId
                }]
            })

            this.classList.remove("loading");

            // open cart
            await openCart();
        })

    })

    /**
     * Given a selling plan id, find the master selling plan object
     * @param {Object} product
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(product, sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }

}())